import DealershipPanel from './dealershipPanel.container';

export default DealershipPanel;